import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import moment from "moment/moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { WorkdayReportService } from "../../workday-report.service";
import { ActivatedRoute, Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { TutorialService } from "app/auth/service/tutorial.service";

@Component({
  selector: "app-user-report-view",
  templateUrl: "./single-user-report.component.html",
  styleUrls: ["./single-user-report.component.scss"]
})
export class SingleUserReportComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("tableHeader") tableHeader: ElementRef;
  public contentHeader: IContentHeader;
  public currentMonthAndYear: any = moment().format("MMMM YYYY"); //Il mese e anno corrente del report (isStaffMode false)
  public lastDayCurrentMonth: any = moment().endOf("month").format("DD");
  public myReport: any = {}; // Sarà contenuto il report generato e anche quello caricato(sia dall'utente che da parte della visualizzazione dello staff
  public available_working_days: Array<number> = [];
  public totalWorkedHours: number = 0;
  public totalNotWorkedHours: number = 0;
  public totalExtraHours: number = 0;
  public daysOfTheMonth: any = [];
  public absence: any = []; //Contiene le assenze dell'utente
  public categoriesAbsencesList: any = [];
  public unlockDay: any; //Viene valorizzato con i giorni in cui il report sarà sbloccato
  public lockReport: boolean = false; //Variabile che gestisce il blocco del send
  public today: any = moment().format("DD-MM-YYYY");

  public idReport: number = null; //Variabile valorizzata solo nel caso della modalità isStaffMode true

  public reportMonth: number = moment().month() + 1;

  public reportYear: number = moment().year();

  public statusReport: number = -1;

  public statusNoteReport: string = "";

  public myProfile: any;

  public daysUnlockReport: any = 5;

  public rowsWithErrorMissingHours: string[] = [];

  public openedRow: string = "";

  canSendReport: boolean = false;

  isArchivedReport = false

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _workdayReport: WorkdayReportService,
    private activatedRoute: ActivatedRoute,
    public _routerService: Router,
    public _userService: UserService,
    private _changeDetectorRef: ChangeDetectorRef,
    public _tutorialService: TutorialService
  ) {
    this._utilService.disableAutoHideLoading();
    this._utilService.showLoading();
    // gestione dei parametri url
    this.activatedRoute.params.subscribe((params) => {
      if (params.hasOwnProperty("id")) {
        //Se è presente un id entriamo in staffMode
        this.idReport = Number(params.id);
      }
    });
    // gestione dei query params
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.hasOwnProperty("month")) {
        this.reportMonth = Number(params.month);
      }

      if (params.hasOwnProperty("year")) {
        this.reportYear = Number(params.year);
      }
    });

    this.contentHeader = {
      headerTitle: "MENU.YOUR_WORKDAY_REPORT",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.WORKDAY_USER_REPORT",
            isLink: false
          },
          {
            name: "MENU.YOUR_WORKDAY_REPORT",
            isLink: false
          }
        ]
      }
    };
    // Parametro gestito da configurazione per i giorni lavorativi
    this.available_working_days = this._utilService.themeConfiguration.working_days;
  }

  async ngOnInit() {
    this.daysUnlockReport = this._utilService.themeConfiguration.days_unlock_report;
    this.myProfile = await this._userService.getMe();
    //In caso sia un collaboratore lo indirizziamo a un altro componente(collaborator-report-view)
    if (this.myProfile.role === "Collaboratore") {
      await this._routerService.navigateByUrl("/dashboard/workday-report/collaborator/user-report");
      return false;
    }
    // prendo la lista delle tipologie di assenza
    this.categoriesAbsencesList = await this._workdayReport.getCategoriesList();
    //////////////////////////////////////
    this.calculateUnlockDay();
    await this.selectReport()
      .then(() => {
        for (const date of Object.keys(this.myReport)) {
          if (this.myReport[date].commissions.length > 0 || this.myReport[date].structures.length > 0) {
            this.canSendReport = true;
            break;
          }
        }
      });

    this._utilService.hideLoading();
    // gestione sticky table header
    if (this._utilService.isDesktop) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 270) {
          if (!this.tableHeader.nativeElement.classList.contains("sticky")) {
            this.tableHeader.nativeElement.classList.add("sticky");
          }
        } else {
          this.tableHeader.nativeElement.classList.remove("sticky");
        }
      });
    }
  }

  calculateUnlockDay() {
    // controllo se questo combacia con il mese di fine rapporto
    const contractEnd: any = this.myProfile.contract_end_date ? moment(this.myProfile.contract_end_date) : null;
    if (contractEnd && contractEnd.format("MMMM") === moment().format("MMMM")) {
      this.unlockDay = moment().set("month", this.reportMonth - 1).format("YYYY-MM-01");
      this.lockReport = false;
      return true;
    }

    // controllo se questo combacia con il mese di licenziamento
    const contractClosedAt: any = this.myProfile.contract_closed_at ? moment(this.myProfile.contract_closed_at) : null;
    if (contractClosedAt && contractClosedAt.format("MMMM") === moment().format("MMMM")) {
      this.unlockDay = moment().set("month", this.reportMonth - 1).format("YYYY-MM-01");
      this.lockReport = false;
      return true;
    }

    const reportDateMax = this._utilService.themeConfiguration.user_report_max_day; //Oggetto contente per ogni mese la data di sblocco
    const currentMonth = moment().month() + 1;
    //Controllo data dinamica se è a zero entreremo nell'else e calcoleremo la data di sblocco negli ultimi sette giorni lavorativi
    if (reportDateMax && reportDateMax[currentMonth] > 0) {
      this.unlockDay = moment(reportDateMax[currentMonth], "D").set("month", this.reportMonth - 1).format("YYYY-MM-DD");
      this.lockReport = (Number(moment().format("DD")) < reportDateMax[currentMonth]);
    } else {
      let array: any = [];
      for (let i = this.lastDayCurrentMonth - 14; i <= this.lastDayCurrentMonth; i++) {
        const date: any = moment(i + "/" + moment().format("MM/YYYY"), "D/MM/YYYY");
        const isWeekEnd: boolean = !this.available_working_days.includes(Number(date.format("d")));
        const isHoliday: boolean = this._utilService.isHoliday(date);
        if (array.length < 14 && !isWeekEnd && !isHoliday) {
          array.push(date);
        }
      }
      /**
       * daysUnlockReport parametro gestito dallo staff in configurazioni,
       * ad esempio il suo valore è cinque, sarà possibile inviare il rapportino cinque giorni lavorativi prima della fine del mese corrente
       */
      this.unlockDay = array[array.length - this.daysUnlockReport];
      /**
       * data di sblocco del rapportino
       */
      this.lockReport = moment().set("month", this.reportMonth - 1).subtract(1, "days").diff(this.unlockDay, "day") < 0;
    }
  }

  /*Funzione che sceglie se generare un report nel caso non vi siano report salvati a database per il periodo corrente, oppure se presente carica il report del database*/
  async selectReport() {
    /**
     * se c'è l'id nell'url vado a prendere direttamente quello
     */

    if (this.idReport) {
      const savedReport = await this._workdayReport.get(this.idReport);
      if (!savedReport) {
        await this._routerService.navigateByUrl("/dashboard/workday-report/my-archive");
        return false;
      }
      this.statusReport = savedReport.status;
      this.statusNoteReport = savedReport.status_note;
      this.reportMonth = savedReport.month;
      this.reportYear = savedReport.year;
      this.myReport = {};
      for (const item of savedReport.data) {
        const day: string = moment(item.date, "YYYY-MM-D").format("YYYY-MM-DD");
        delete item.date;
        this.myReport[day] = item;
      }

      this.totalExtraHours = savedReport.extra_hours;
      this.totalWorkedHours = savedReport.worked_hours;
      // this.unlockDay = null;
    } else {
      const savedReport: any = await this._workdayReport.getMineByDate(this.reportMonth, this.reportYear).then((result: any) => (!result || Object.keys(result).length < 1 ? null : result));

      this.idReport = savedReport.id;
      this.statusReport = savedReport.status;
      this.statusNoteReport = savedReport.status_note;
      this.myReport = {};
      for (const item of savedReport.data) {
        const day: string = moment(item.date, "YYYY-MM-D").format("YYYY-MM-DD");
        delete item.date;
        this.myReport[day] = item;
      }
      /**
       * aggiorno le somme
       */
      this.calculateTotalHours();
    }

    this.isArchivedReport = this.reportMonth < moment().month() + 1 && this.reportYear <= moment().year();

    // prendo i giorni del mese dall'oggetto
    this.daysOfTheMonth = Object.keys(this.myReport);
    this.currentMonthAndYear = moment(`${this.reportYear}-${this.reportMonth}`, "YYYY-MM").format("MMMM YYYY");

    const working_days = this.daysOfTheMonth.filter((date: string) => {
      const day = moment(date);
      return this._utilService.themeConfiguration.working_days.includes(day.day()) && !this._utilService.isHoliday(day);
    });
    const last_working_day = working_days.pop();
    if (this.reportMonth - 1 < moment().month()) {
      let days_with_commissions: string[] = [];
      for (const day of working_days) {
        const value = this.myReport[day];
        if (value.working_hours > 0 && value.structures.length > 0 && value.commissions.length > 0 && !this._utilService.isHoliday(day)) {
          days_with_commissions.push(day);
        }
      }

      if (days_with_commissions.length) {
        const last_day_with_commissions = days_with_commissions.pop();

        if (!last_day_with_commissions) {
          const day = moment(working_days[0]).set("month", this.reportMonth - 1).format("DD MMMM");
          const text = await this._utilService.translate("MISSING_COMMISSIONS_FOR_WORKING_DAY").then((text: string) => text.replace("DATA", day));
          this._utilService.hideLoading();
          await this._utilService.showSWALEmptyField({ text });

        } else if (last_working_day != last_day_with_commissions && last_day_with_commissions != moment().endOf("month").format("YYYY-MM-DD")) {
          const day = moment(last_day_with_commissions).set("month", this.reportMonth - 1).format("DD MMMM");
          const text = await this._utilService.translate("MISSING_COMMISSIONS_FOR_WORKING_DAY").then((text: string) => text.replace("DATA", day));
          this._utilService.hideLoading();
          await this._utilService.showSWALEmptyField({ text });
        }
      }
    }
  }

  //Funzione per gestire i colori della visualizzazione della lista
  isWorkDay(day: string) {
    const dayN: number = Number(moment(day).format("d"));
    return this.available_working_days.includes(dayN);
  }

  getDayRowClasses(day: string) {
    let classes: string[] = [];

    if (this.isWorkDay(day)) {
      if (this._utilService.isHoliday(day)) {
        classes.push("holiday");
      } else {
        classes.push("work");
      }
    } else {
      classes.push("off");
    }

    if (this.rowsWithErrorMissingHours.includes(day)) {
      classes.push("bg-light-danger");
    }

    return classes.join(" ");
  }

  getDayRowTooltip(day: any) {
    if (this.rowsWithErrorMissingHours.includes(day)) {
      return "MISSING_SOME_HOURS_TO_ALLOCATE";
    }
    return null;
  }

  checkErrors() {
    let sumHours: number = 0;

    for (const type of ["commissions", "structures"]) {
      for (let element of this.myReport[this.openedRow][type]) {
        sumHours += element.worked;

        // se l'extra non è valido lo resetto
        if (element.extra.type == null || element.extra.hours === 0 || element.extra.type_name == "") {
          element.extra = {
            hours: 0,
            type: null,
            type_name: ""
          };
        }
      }
    }

    if (sumHours < this.myReport[this.openedRow].working_hours) {
      this.rowsWithErrorMissingHours.push(this.openedRow);
    } else {
      this.rowsWithErrorMissingHours = this.rowsWithErrorMissingHours.filter((d: string) => d !== this.openedRow);
    }

    this.calculateTotalHours();
  }

  openRow(day: string) {
    if (this.statusReport === 1 || this.hasFullDayAbsence(day) || (day !== "" && this.myReport[day].commissions.length < 1 && this.myReport[day].structures.length < 1)) {
      return false;
    }

    if (!!this.openedRow) {
      this.checkErrors();
    }
    day = day === this.openedRow ? "" : day;

    setTimeout(() => {
      this.openedRow = day;
    }, 1);
  }

  setExtra($event: any, day: any, i: number, type: string = "commissions") {
    this.myReport[day][type][i].extra.type_name = $event.name;
    this.myReport[day][type][i].extra.type = $event.id;
    this.calculateTotalExtraHours();
  }

  setExtraHours(target: any, type: string = "commissions", day: string, commissionIndex: number) {
    const myDay: any = this.myReport[day];
    myDay[type][commissionIndex].extra.hours = Number(target.value) > Number(target.max) ? Number(target.max) : Number(target.value);
    target.value = myDay[type][commissionIndex].extra.hours;
    this.calculateTotalExtraHours();
  }

  setWorkedHours(target: any) {
    const day: string = target.date;
    const commissionIndex: string = target.commission_index;

    const myDay: any = this.myReport[day];

    myDay.commissions[commissionIndex].worked = Number(target.value) > Number(target.max) ? Number(target.max) : Number(target.value);

    target.value = myDay.commissions[commissionIndex].worked;

    myDay.allocated_hours = 0;

    for (let comm of myDay.commissions) {
      myDay.allocated_hours += comm.worked;
    }

    myDay.residual_hours = Number(myDay.working_hours) - Number(myDay.allocated_hours);
    myDay.residual_hours = myDay.residual_hours < 0 ? 0 : myDay.residual_hours;
  }

  cancelExtraHour(day: any, i: number, field: string = "commissions") {
    this.myReport[day][field][i].extra = {
      hours: 0,
      type: null,
      type_name: ""
    };
  }

  private calculateTotalHours() {
    // Calcolo ore totali di lavoro
    this.totalWorkedHours = 0;
    // Calcolo ore totali non lavorative
    this.totalNotWorkedHours = 0;
    const daysList: any = Object.values(this.myReport);
    for (let day of daysList) {
      // totali
      this.totalWorkedHours += day.working_hours;
      // ferie
      for (const ab of day.absences) {
        this.totalNotWorkedHours += ab.hours;
      }
    }

    this.calculateTotalExtraHours();

    this._changeDetectorRef.detectChanges();
  }

  calculateTotalExtraHours() {
    // Calcolo ore extra
    this.totalExtraHours = 0;
    const daysList: any = Object.values(this.myReport);
    for (let day of daysList) {
      // extra dalle commesse
      for (const comm of day.commissions) {
        if (!!comm.extra.hours && !!comm.extra.type) {
          comm.extra.hours = Number(comm.extra.hours);
          this.totalExtraHours += comm.extra.hours;
        }
      }
      // extra dai costi di struttura
      for (const structure of day.structures) {
        if (!!structure.extra.hours && !!structure.extra.type) {
          structure.extra.hours = Number(structure.extra.hours);
          this.totalExtraHours += structure.extra.hours;
        }
      }
    }
  }

  /**
   * controllo se in quel giorno c'è una feria o una malattia
   */
  hasFullDayAbsence(day: string) {
    const selectedDay: any = this.myReport[day];
    if (selectedDay.absences.length == 1 && selectedDay.absences[0].code === "F1") {
      return false;
    }
    return selectedDay.absences.find((ab: any) => ab.hours === 8);
  }

  /**
   * funzione per l'invio del rapportino
   */
  async save() {
    // controllo il giorno per vedere se posso inviarlo o no
    if (this.lockReport && !this.isArchivedReport) {
      await this._utilService.showSWALError({ text: "YOU_CANNOT_SEND_WORKDAYREPORT_YET" });
      return false;
    }
    /**
     *  controllo se manca qualche ora e registro i giorni incompleti
     **/
    for (let day of Object.keys(this.myReport)) {
      if (this.myReport[day].residual_hours > 0) {
        this.rowsWithErrorMissingHours.push(day);
      }
    }
    // controllo non ci siano ore in eccesso rispetto a quelle lavorate
    for (const day of Object.keys(this.myReport)) {
      for (let comm of this.myReport[day].commissions) {
        if (comm.worked > this.myReport[day].working_hours) {
          comm.worked = this.myReport[day].working_hours;
        }
      }
    }
    // se c'è qualche errore esco dalla funzione
    if (this.rowsWithErrorMissingHours.length > 0) {
      await this._utilService.showSWALError({ text: "YOU_FORGOT_SOME_HOURS_IN_YOUR_REPORT" });
      return false;
    }

    this._utilService.showLoading();

    return this._workdayReport
      .create({
        report: this.myReport,
        status: 1,
        worked_hours: this.totalWorkedHours,
        extra_hours: this.totalExtraHours
      })
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_WORKDAY_REPORT" });
        await this.selectReport();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_SEND_WORKDAY_REPORT" });
      });
  }

  async update() {
    // controllo il giorno per vedere se posso inviarlo o no
    if (this.lockReport && !this.isArchivedReport) {
      await this._utilService.showSWALError({ text: "YOU_CANNOT_SEND_WORKDAYREPORT_YET" });
      return false;
    }
    /**
     *  controllo se manca qualche ora e registro i giorni incompleti
     **/
    for (let day of Object.keys(this.myReport)) {
      if (this.myReport[day].residual_hours > 0) {
        this.rowsWithErrorMissingHours.push(day);
      }
    }
    // controllo non ci siano ore in eccesso rispetto a quelle lavorate
    for (const day of Object.keys(this.myReport)) {
      for (let comm of this.myReport[day].commissions) {
        if (comm.worked > this.myReport[day].working_hours) {
          comm.worked = this.myReport[day].working_hours;
        }
      }
    }
    // se c'è qualche errore esco dalla funzione
    if (this.rowsWithErrorMissingHours.length > 0) {
      const html: string = await this._utilService.translate("YOU_FORGOT_SOME_HOURS_IN_YOUR_REPORT");
      await this._utilService.showSWALError({ html });
      return false;
    }

    this._utilService.showLoading();

    return this._workdayReport
      .update(this.idReport, {
        report: this.myReport,
        status: 1,
        worked_hours: this.totalWorkedHours,
        extra_hours: this.totalExtraHours
      })
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_WORKDAY_REPORT" });
        await this.selectReport();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_SEND_WORKDAY_REPORT" });
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Rapportino";
    this._tutorialService.force_open_modal = true;
  }
}
